import { useParams } from "react-router";
import { trpc } from "../../../utils/trpc";

export function useIsAdmin(opts: { disabled?: boolean } = {}) {
	const { server_id } = useParams<{ server_id: string }>();
	return trpc.members.isAdmin.useQuery(
		{
			guild_id: server_id,
		},
		{
			enabled: !opts.disabled,
			staleTime: 1000 * 60 * 10,
			refetchOnMount: false,
			refetchOnWindowFocus: false,
		}
	);
}
